export const mapPermissionToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfRole: item?.roles?.length,
  }));

  return result;
};

export const permissionColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "description", label: "Description", align: "center" },
  {
    key: "numOfRole",
    label: "Number Of Permission",
    align: "center",
  },
];
